// extracted by mini-css-extract-plugin
module.exports = {"spinner":"ApplicationValidationVotesModal_spinner__rIa3z"};